import { createAction } from 'typesafe-actions'

import { Id } from 'src/types'

import { BedroomsOfferActionTypes, ResponseDataRequests } from './types'

type Options = {
  page?: number
  agency_partner_id: Id
  partner_hotel_room_id?: Id
  request_agency_ids?: string[]
}

export const getBedroomsOffer = createAction(
  BedroomsOfferActionTypes.GET_BEDROOMS_OFFER,
  action =>
    (
      options = {
        page: 1,
        agency_partner_id: '',
        partner_hotel_room_id: '',
        request_agency_ids: []
      } as Options
    ) =>
      action({ options })
)

export const getBedroomsOfferFailure = createAction(
  BedroomsOfferActionTypes.GET_BEDROOMS_OFFER_FAILURE,
  action => (message: string) => action({ message })
)

export const getBedroomsOfferSuccess = createAction(
  BedroomsOfferActionTypes.GET_BEDROOMS_OFFER_SUCCESS,
  action =>
    ({ agency_partner_hotel_offers }: ResponseDataRequests) =>
      action({ agency_partner_hotel_offers })
)

export const sendBedroomsOffer = createAction(
  BedroomsOfferActionTypes.SEND_BEDROOMS_OFFER,
  action =>
    (
      agency_partner_hotel_offers: [
        {
          agency_partner_id: Id
          partner_hotel_room_id?: Id
          agency_partner_hotel_offer_id?: Id
          start_date?: String
          end_date?: String
          pension?: Boolean
          fare_value?: Number
          tax_value?: Number
          description?: String
          active: Boolean
          agency_partner?: {
            agency_partner_id: Id
            partner_id: Id
            description: String
            active: Boolean
          }
          agency_partner_hotel_agreement?: {
            agency_partner_hotel_agreement_id: Id
            agency_partner_hotel_offer_id: Id
            agreement: {
              agreement_id: Id
              organization_id: Id
              service_hub_id: Id
              agreement_type: String
              integration_type: String
              name: String
              code: String
            }
          }
        }
      ]
    ) =>
      action({ agency_partner_hotel_offers })
)

export const sendBedroomsOfferFailure = createAction(
  BedroomsOfferActionTypes.SEND_BEDROOMS_OFFER_FAILURE,
  action => (message: string) => action({ message })
)

export const sendBedroomsOfferSuccess = createAction(
  BedroomsOfferActionTypes.SEND_BEDROOMS_OFFER_SUCCESS,
  action => () => action()
)
